<template>
  <div class="CopyInput">
    <input
    class="CopyInput__input"
    type="text"
    :value="inputValue"
    :disabled="disabled">
    <div
    @click="copyValue"
    ref="InputIcon"
    class="CopyInput__icon">
      <SvgImage
      imageName="Copy"/>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'

export default {
  name: 'CopyInput',

  props: {
    inputValue: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  watch: {
    inputValue () {
      this.$refs.InputIcon.classList.remove('CopyInput__icon--active')
    }
  },

  methods: {
    copyValue () {
      this.$refs.InputIcon.classList.remove('CopyInput__icon--active')
      const input = document.createElement('input')
      input.setAttribute('value', this.inputValue)
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$refs.InputIcon.classList.add('CopyInput__icon--active')
      } catch (error) {
        Message({
          type: 'error',
          message: 'Oops, we were unable copy this link',
          showClose: true
        })
      }
    }
  }
}
</script>

<style lang="scss">
.CopyInput {
  display: inline-flex;
  width: 100%;
  &__input {
    @extend %input-underline;
    flex-basis: 100%;
    font-size: 16px;
  }

  &__icon {
    position: relative;
    flex-basis: 20px;
    height: 20px;
    margin: 0 10px;
    background: transparent;
    cursor: pointer;

    &--active {
      &::before {
        position: absolute;
        top: -15px;
        left: 0;
        width: 100%;
        color: $brand-success;
        content: 'Copied!';
        font-size: 0.9em;
        transform: translateX(-60%);
        animation: fadeInAndOut 1s;
        opacity: 0;
      }
    }
  }
}

</style>
